<template>
  <div class="home-component Home">
    <Slider />
    <br />
    <div class="container">
      <nav aria-label="breadcrumb"></nav>
    </div>
    <template v-if="banner_data != null">
      <BestProducts :banner="banner_data"></BestProducts>
    </template>
    <TwoModules></TwoModules>
    <News></News>
    <Instagram></Instagram>
    <Guide></Guide>
  </div>
</template>
<script>
import { config_settings } from '@/config.js';
import axios from 'axios';

// @ is an alias to /src
import Instagram from '@/components/products/Instagram.vue';
import TwoModules from '@/components/products/TwoModules.vue';
import NewModules from '@/components/products/NewModule.vue';
import News from '@/components/products/News.vue';
import Guide from '@/components/products/Guia.vue';
import Slider from '@/components/slider/Slider.vue';
import BestProducts from '@/components/products/BestProducts.vue';
import TopProducts from '@/components/products/TopProducts.vue';
import Map from '@/components/products/Map.vue';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;
const CONFLICT = 409;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' },
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error('Usted no tiene los provilegios para acceder a esta sección', 'ERROR', {
          iconClass: 'customer-danger',
        });
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  name: 'home',
  components: {
    Slider,
    //HelloWorld,
    BestProducts,
    TwoModules,
    NewModules,
    Instagram,
    News,
    Guide,
    // TopProducts
    Map,
  },
  props: ['subSectionData'],
  data() {
    return {
      slider_list: [],
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      cod_sub_sec: 5,
      nom_sub_sec_es: '',
      nom_sub_sec_en: '',
      internal_name_es: '',
      internal_name_en: '',
      desc_sub_section_es: '',
      desc_sub_section_en: '',
      section: '',
      url_1st_image: 'products/empty-img',
      url_2nd_image: 'products/empty-img',
      url_3rd_image: 'products/empty-img',
      url_4th_image: 'products/empty-img',
      url_5th_image: 'products/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      type_4th_image: 'image',
      type_5th_image: 'image',
      text1_es: '',
      text1_en: '',
      text2_es: '',
      text2_en: '',
      text3_es: '',
      text3_en: '',
      orientation: '',
      url_es: '',
      url_en: '',
      order_sub_section: '',
      id_position_menu: '',
      url_video: '',
      type: '',

      banner_data: {
        first: { photo: 'products/empty-img', url: 'www.google.com' },
        second: { photo: 'products/empty-img', url: 'www.google.com' },
        third: { photo: 'products/empty-img', url: 'www.google.com' },
      },
    };
  },
  methods: {
    scroll_inicio() {
      window.scrollTo(0, 0);
    },
    obtener_sub_section_data() {
      this.nom_sub_sec_es = this.subSectionData.nom_sub_sec_es;
      this.nom_sub_sec_en = this.subSectionData.nom_sub_sec_en;
      this.internal_name_es = this.subSectionData.internal_name_es;
      this.internal_name_en = this.subSectionData.internal_name_en;
      this.desc_sub_section_es = this.subSectionData.desc_sub_section_es;
      this.desc_sub_section_en = this.subSectionData.desc_sub_section_en;
      this.section = this.subSectionData.section;
      this.url_1st_image = this.subSectionData.url_1st_image;
      this.url_2nd_image = this.subSectionData.url_2nd_image;
      this.url_3rd_image = this.subSectionData.url_3rd_image;
      this.url_4th_image = this.subSectionData.url_4th_image;
      this.url_5th_image = this.subSectionData.url_5th_image;
      this.type_1st_image = this.subSectionData.type_1st_image;
      this.type_2nd_image = this.subSectionData.type_2nd_image;
      this.type_3rd_image = this.subSectionData.type_3rd_image;
      this.type_4th_image = this.subSectionData.type_4th_image;
      this.type_5th_image = this.subSectionData.type_5th_image;
      this.text1_es = this.subSectionData.text1_es;
      this.text1_en = this.subSectionData.text1_en;
      this.text2_es = this.subSectionData.text2_es;
      this.text2_en = this.subSectionData.text2_en;
      this.text3_es = this.subSectionData.text3_es;
      this.text3_en = this.subSectionData.text3_en;
      this.orientation = this.subSectionData.orientation;
      this.url_es = this.subSectionData.url_es;
      this.url_en = this.subSectionData.url_en;
      this.order_sub_section = this.subSectionData.order_sub_section;
      this.id_position_menu = this.subSectionData.id_position_menu;
      this.url_video = this.subSectionData.url_video;
      this.type = this.subSectionData.type;

      this.banner_data = {
        first: { photo: this.url_1st_image, url: this.type_1st_image },
        second: { photo: this.url_2nd_image, url: this.type_2nd_image },
        third: { photo: this.url_3rd_image, url: this.type_3rd_image },
      };
    },
  },
  created() {
    this.scroll_inicio();
    this.obtener_sub_section_data();
  },
};
</script>

<style lang="scss" src="./Home.scss"></style>
